import React from 'react';
import Contact from './Contact';
import Footer from './Footer';
import Fade from 'react-reveal';
import eventdata from './Eventdata';
import './club.css'

export default function Pageclub(){
    return(
        <>
            <Fade top distance = '1%' duration = {3000}>
                <div className='clubpage'>
                    <div className='informals'>
                        <div className='title'>
                            <h1>TechnoInformals</h1>
                            <img src= {require('./images/techno_black.png')}></img>
                        </div>
                        <div className='info'>
                            <p className='role'>Member</p>
                            <p className='caption'>The Entertainment and Management Cluster of SASTRA University</p>
                            <p className='desc'>We organise events during Kuruksastra And Daksh - the Fests of SASTRA. Events that engage a large volume of audience ranging from 400-600 people organised by a total of 30 club members. </p>
                        </div>
                        <Fade top distance = '5%' duration = {3000}>
                            <div className='events'>
                                <h1>Events</h1>
                                {eventdata.map((d,i) => (
                                    <div className='cards'>
                                        <div class="card border-light mb-3 cardbox" key = {i}>
                                            <img class="card-img-top" src= {require('./images/events/' + d.imgsource)} alt="Card image cap" ></img>
                                            <div class="card-body">
                                                {/* <p class="card-text">{d.name}</p> */}
                                                <p class="card-text"><small class="text-muted">{d.timing}</small></p>
                                                <p class="card-text">{d.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Fade>
                        {/* <div className='photos'>

                        </div> */}
                    </div>
                    <Fade top distance = '5%' duration = {3000}>
                        <div className='dpi300'>
                            <div className='title'>
                                <h1>300dpi</h1>
                                <img src= {require('./images/300dpi_black.png')}></img>
                            </div>
                            <div className='info'>
                                <p className='role'>Graphic Designer</p>
                                <p className='caption'>Official Design and Development Club of SASTRA University</p>
                                <p>We design all the posters and graphic content for Both Kuruksastra and Colosseum - Cultural and Sports Fests of SASTRA. This includes Event posters, Merchandise, Brochures, Promo Videos, Flexes, etc.</p>
                            </div>
                            <Fade top distance = '5%' duration = {3000}>
                                <div className='photos'>
                                    <h1>My Graphic Designs</h1>
                                    <img id='img1' src= {require('./images/posters/knight.jpg')}></img>
                                    <img id='img2' src= {require('./images/posters/moneyball.png')}></img>
                                    <img id='img3' src= {require('./images/posters/pirate.png')}></img>
                                    <img id='img4' src= {require('./images/posters/sherlock.png')}></img>
                                    <img id='img5' src= {require('./images/posters/sos.jpg')}></img>
                                    <img id='img6' src= {require('./images/posters/upahar.jpg')}></img>
                                </div>
                            </Fade>
                        </div>
                    </Fade>
                </div>
                <Contact />
                <Footer />
            </Fade>
        </>
    );
}